import { NavigationItem } from "@/config/navigation/types";

export function sortAppsByOrder(apps: NavigationItem[], order: string[]): NavigationItem[] {
  const orderIndex = new Map(order.map((id, index) => [id, index]));
  const fallbackOffset = order.length;

  return apps
    .map((app, index) => ({
      app,
      sortKey: orderIndex.get(app.id) ?? fallbackOffset + index,
    }))
    .sort((a, b) => a.sortKey - b.sortKey)
    .map(({ app }) => app);
}
